import { render, staticRenderFns } from "./SettingsDiscounts.vue?vue&type=template&id=a1acacae&"
import script from "./SettingsDiscounts.vue?vue&type=script&lang=js&"
export * from "./SettingsDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports